module.exports = __webpack_public_path__ + "static/contribution_img5@2x-a9e8ddeb718fb607ad88a1767b04ad78.jpg";